import {Injectable} from 'ng-metadata/core';
import{AbstractRequest} from './abstractRequest';
import {FormBuilderEnums} from '../../../../../../infra/formBuilder/formBuilder.service';
import { MappingTablesCache } from '../../../../../../mappingTablesCache/mappingTablesCache.service';
import { ConfigurationUtil } from '../../../../../../nddUtils/configurationUtil.service';

@Injectable()
export class HoldRequest extends AbstractRequest {

	constructor(
        private mappingTablesCache : MappingTablesCache,
        private configurationUtil:ConfigurationUtil
    ){
		super();
		this.formFields = [
			{
				key: 'year',
				name: 'year',
                path: 'groups-list-map/year',
				label: 'hold.year',
				mandatory: false,
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
				populator:  {
					func:       this.itemsArrayPopulator.bind(this),
					params:     {
						filters :['volume','item-description',
                                  'secondary-location-name','main-location-name','item-category',
                                  'item-status','item-material','option-description','pickup_location']
					}
				},
				events: {
					onChange: this.onChange.bind(this),
					params: []
				}
			},
			{
				key: 'volume',
				name: 'volume',
                path: 'groups-list-map/volume',
				label: 'hold.volume',
				mandatory: false,
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
				populator:  {
					func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        filters :['year','item-description',
                                  'secondary-location-name','main-location-name','item-category',
                                  'item-status','item-material','option-description','pickup_location']
                    }
				},
				events: {
					onChange: this.onChange.bind(this),
					params: []
				}
			},
			{
				key: 'item_description',
				name: 'item-description',
                path: 'groups-list-map/item-description',
				label: 'hold.item_description',
				mandatory: true,
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
				populator:  {
					func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        filters :['year','volume',
                                  'secondary-location-name','main-location-name','item-category',
                                  'item-status','item-material','option-description','pickup_location']
                    }
				},
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
			},
			{
				key: 'secondary_location_name',
				name: 'secondary-location-name',
                path: 'groups-list-map/secondary-location-name',
				label: 'hold.secondary_location',
				mandatory: true,
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
				populator:  {
					func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        filters :['year','volume','item-description',
                                  'main-location-name','item-category',
                                  'item-status','item-material','option-description','pickup_location']
                    }
				},
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
			},
			{
				key: 'main_location_name',
				name: 'main-location-name',
                path: 'groups-list-map/main-location-name',
				label: 'hold.main_location',
				mandatory: true,
				value: '',
 				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
				populator:  {
					func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        filters :['year','volume','item-description',
                                  'secondary-location-name','item-category',
                                  'item-status','item-material','option-description','pickup_location']
                    }
				},
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
			},
			{
				key: 'item_category_name',
				name: 'item-category',
                path: 'groups-list-map/item-category',
				label: 'hold.item_category',
				mandatory: true,
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
				populator:  {
					func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        filters :['year','volume','item-description',
                                  'secondary-location-name','main-location-name',
                                  'item-status','item-material','option-description','pickup_location']
                    }
				},
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
			},
			{
				key: 'item_status_name',
				name: 'item-status',
                path: 'groups-list-map/item-status',
				label: 'hold.item_status',
				mandatory: true,
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
				populator:  {
					func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        filters :['year','volume','item-description',
                                  'secondary-location-name','main-location-name','item-category',
                                  'item-material','option-description','pickup_location']
                    }
				},
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
			},
			{
				key: 'item_material',
				name: 'item-material',
                path: 'groups-list-map/item-material',
				label: 'hold.item_material',
				mandatory: true,
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
				populator:  {
					func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        filters :['year','volume','item-description',
                                  'secondary-location-name','main-location-name','item-category',
                                  'item-status','option-description','pickup_location']
                    }
				},
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
			},
			{
				key: 'option_description',
				name: 'option-description',
                path: 'groups-list-map/option-description',
				label: 'hold.option_description',
				mandatory: true,
				value: '',
 				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        filters :['year','volume','item-description',
                                  'secondary-location-name','main-location-name','item-category',
                                  'item-status','item-material','pickup_location']
                    }
                },
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }
			},
			{
				key: 'pickup_locations',
				name: 'pickup_location',
                path: 'groups-list-map/pickup_locations',
				label: 'hold.pickup_location',
				mandatory: true,
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
				populator:  {
					func:       this.itemsArrayPopulator.bind(this),
					params:     {
						key: 'pickuplocationcode',
						value:'pickuplocationname',
 						filters :['year','volume','item-description',
                                  'secondary-location-name','main-location-name','item-category',
                                  'item-status','item-material','option-description']
					}
				},
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                }

			},
            /* group id - internal field */
            {
                key: 'group_id',
                name: 'group_id',
                label: 'group_id',
                path: 'groups-list-map/group-id',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                         filters :['year','volume','item-description',
                                  'secondary-location-name','main-location-name','item-category',
                                  'item-status','item-material','pickup_location','option-description']
                    }
                }

            },
            {
                /* Voyager */
                key: 'request-option',
                name: 'item_id',
                path: 'request-option',
                label: 'hold.dropdown.select.item',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'optionid',
                        value:'optiondescription',
                        defaultValue: FormBuilderEnums.FIRST
              
                    }
                }
            },
			{
                /* Voyager */
				key: 'locations',
				name: 'pickup_location',
				label: 'hold.pickup_location',
                path: 'ordered-locations',
				mandatory: true,
				value: '',
                duplicateOf : 'pickup_location',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
				populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'pickuplocationcode',
                        value:'pickuplocationname'
                    }
				}

			},
			{
				key: 'last_interest_date',
				name: 'last_interest_date',
				label: 'hold.last_interest_date',
				mandatory: false,
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.DATE,
				uiType: FormBuilderEnums.UI_TYPE.DATE,
                populator:  {
                    params:     {
                        defaultValue: FormBuilderEnums.TODAY,
                        allow       : FormBuilderEnums.FUTURE_DATES
                    }
                }
			},
			{
				key: 'request_author',
				name: 'request_author',
				label: 'hold.request_author',
				mandatory: false,
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.TEXT
			},
			{
				key: 'request_title',
				name: 'request_title',
				label: 'hold.request_title',
				mandatory: false,
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.TEXT
			},
			{
				key: 'request_pages',
				name: 'request_pages',
				label: 'hold.request_pages',
				mandatory: false,
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.TEXT
			},
			{
				key: 'patron_note_1',
				name: 'patron_note_1',
				label: 'hold.patron_note_1',
				mandatory: false,
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.TEXT
			},
			{
				key: 'patron_note_2',
				name: 'patron_note_2',
				label: 'hold.patron_note_2',
				mandatory: false,
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.TEXT
			},
			{
				key: 'rush_request',
				name: 'rush_request',
				label: '',
				mandatory: false,
				value: '',
				fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
				uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
                populator:  {
                    func:       this.hardCodedPopulator.bind(this)
                },
                options:[
                    {
                        label:'hold.rush_request',
                        value:'Y'
                    }
                ]
			},
            {
                key: 'ils_db_code',
                name: 'ils_db_code',
                path: 'optional-service-parameters/ils_db_code',
                label: 'hold.ils_db_code',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        defaultValue: FormBuilderEnums.FIRST
                    }
                   
                }
            },
            /* item level */
            {
                key: 'info-notes',
                name: 'info-notes',
                path: FormBuilderEnums.ROOT,
                label: '',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.INTERNAL,
                uiType: FormBuilderEnums.UI_TYPE.MULTI_LABEL,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this)
                }
            },
            {
                key: 'main_location',
                name: 'main_location',
                path: 'drop-downs/main_location',
                label: 'hold.main_location',
                mandatory: true,
                dependOn: {key : 'info-notes', isExists : false},
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        byKey: 'field-name',
                        byValue:'field-values'
                    }
                }
            },
            {
                key: 'item_description',
                name: 'item-description',
                path: 'drop-downs/item_description',
                label: 'hold.item_description',
                mandatory: true,
                dependOn: {key : 'info-notes', isExists : false},
                value: '',
                duplicateOf : 'item-description',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        byKey: 'field-name',
                        byValue:'field-values'
                    }
                }
            },
            {
                key: 'item_category_name',
                name: 'item-category',
                path: 'drop-downs/item_category',
                label: 'hold.item_category',
                mandatory: false,
                dependOn: {key : 'info-notes', isExists : false},
                value: '',
                duplicateOf : 'item-category',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        byKey: 'field-name',
                        byValue:'field-values'
                    }
                   
                },
            
            },
            {
                key: 'item_status_name',
                name: 'item-status-name',
                path: 'drop-downs/item_status',
                label: 'hold.item_status',
                mandatory: true,
                dependOn: {key : 'info-notes', isExists : false},
                duplicateOf : 'item-status',
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        byKey: 'field-name',
                        byValue:'field-values'
                    }
                }
            }
  
		];

	}
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/holdRequest.ts